import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import SearchInput from './direct-messages/search-input'
import Templates from './direct-messages/templates'
import { ajaxGet } from '../ajax'

function TemplatesModal({onSelect, onClose}) {
  const [templates, setTemplates] = useState(null)
  const [query, setQuery] = useState('')
  
  useEffect(() => {
    loadTemplates()
  }, [])

  const loadTemplates = () => {
    ajaxGet(`/admins/message_templates.json`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => { setTemplates(json.templates) })
  }

  const filteredTemplates = () => {
    if (!query) return templates

    return templates.filter(t => {
      const q = query.toLowerCase()
      return t.title.toLowerCase().includes(q) || t.text.toLowerCase().includes(q)
    })
  }

  const onSelectTemplate = (template) => {
    onSelect(template.text)
    onClose()
  }

  return (
    <Modal container={document.body} id='templates-modal' isOpen={true} onRequestClose={onClose}>
      { !templates && <div className='animated-spinner'></div> }
      { templates &&
        <div className='templates-modal'>
          <SearchInput 
            value={query}
            placeholder='Search Templates'
            onChange={(e) => setQuery(e.target.value)}
          />
          <Templates templates={filteredTemplates()} onSelect={onSelectTemplate} />
          <div className='templates-link'><a href='/admins/message_templates'>Go To Templates</a></div>
        </div>
      }
    </Modal>
  )
}

TemplatesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default TemplatesModal

